export default __webpack_public_path__ + "static/media/type-inline.f9b5d929.svg";